// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2cs3q","log":"ModalInventoryLogs_log__2FTeq","date":"ModalInventoryLogs_date__2T2-h","userName":"ModalInventoryLogs_userName__3J5FD"};